import React from "react";
import AutomationList from "../shared/components/AutomationList";
import { WORKFLOW_CATEGORY } from "../workflow/utils/enums";

const LeadsAutomation: React.FC = () => {
  return (
    <AutomationList
      workflowCategory={WORKFLOW_CATEGORY.LEAD}
      title="Leads Automation"
      breadcrumb="Leads"
      module="leads"
    />
  );
};

export default LeadsAutomation;
